import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { get } from "@/lib/api";
import { DAYS_TR, MONTHS_TR } from "@/lib/data";
import AddSessionDialog from "@/components/partner/AddSessionDialog";

function weekDays() {
  const out = [];
  const today = new Date();
  for (let i = 0; i < 7; i++) {
    const d = new Date(today);
    d.setDate(today.getDate() + i);
    out.push(d);
  }
  return out;
}

export default function Calendar() {
  const { data: sessions = [] } = useQuery({ queryKey: ["partner-calendar"], queryFn: () => get("/partner/calendar") });
  const days = useMemo(weekDays, []);

  const byDate = useMemo(() => {
    const m = {};
    sessions.forEach((s) => { (m[s.date] ||= []).push(s); });
    Object.values(m).forEach((arr) => arr.sort((a, b) => a.start_time.localeCompare(b.start_time)));
    return m;
  }, [sessions]);

  return (
    <div>
      <div className="mb-6 flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">Takvim</h1>
          <p className="text-sm text-[#64748B]">Haftalık seans programı</p>
        </div>
        <AddSessionDialog />
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-7">
        {days.map((d) => {
          const iso = d.toISOString().slice(0, 10);
          const list = byDate[iso] || [];
          const isToday = iso === new Date().toISOString().slice(0, 10);
          const dayIdx = (d.getDay() + 6) % 7;
          return (
            <div key={iso} data-testid={`calendar-day-${iso}`} className="rounded-md border border-[#E2E8F0] bg-white">
              <div className={`border-b border-[#E2E8F0] px-3 py-2.5 text-center ${isToday ? "bg-[#2D2926] text-white" : ""}`}>
                <p className="text-xs font-medium uppercase">{DAYS_TR[dayIdx]}</p>
                <p className="text-lg font-semibold">{d.getDate()} <span className="text-xs font-normal">{MONTHS_TR[d.getMonth()]}</span></p>
              </div>
              <div className="min-h-[120px] space-y-2 p-2">
                {list.length === 0 && <p className="py-4 text-center text-xs text-[#94A3B8]">Seans yok</p>}
                {list.map((s) => (
                  <div key={s.id} className="rounded border border-[#E2E8F0] bg-[#F7F9FA] p-2 text-left">
                    <p className="text-xs font-semibold text-[#2D2926]">{s.start_time}</p>
                    <p className="text-xs text-[#475569]">{s.title}</p>
                    <p className="mt-1 text-[10px] text-[#94A3B8]">{s.booked_count}/{s.capacity} · {s.credit_price} kr</p>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
